import type { CurrencyAmountPair } from "./CurrencyAmountPair";

export class MangopayPayIn {
    public Id: string;

    public Tag: string;

    public CreationDate: string;

    public DebitedFunds: CurrencyAmountPair;

    public CreditedFunds: CurrencyAmountPair;

    public Fees: CurrencyAmountPair;

    public DebitedWalletId: string;

    public CreditedWalletId: string;

    public AuthorId: string;

    public CardId: string;

    public CreditedUserId: string;

    public Nature: string;

    public Status: string;

    public ExecutionDate: number;

    public ResultCode: string;

    public ResultMessage: string;

    public Type: string;

    public PaymentType: string;

    public ExecutionType: string;
}
